/* eslint-disable @typescript-eslint/no-empty-function */
import { Link, Router, useNavigate, useSearchParams } from 'react-router-dom';
import getInitials from '../lib/getInitials';
import Wrapper from '../components/global/Wrapper';
import SettingHeader from '../components/SettingPage/SettingHeader';
import editIcon from '../assets/icons/edit.svg';
import DateInput from '../components/global/DateInput';
import Dropdown from '../common/dropdown/Dropdown';
import SettingSteps from '../components/SettingPage/SettingSteps';
import { useEffect, useState } from 'react';
import axios, { AxiosError } from 'axios';
import { baseUrl_, timeout } from '../utils/constants';
import { useMutation, useQuery } from 'react-query';
import { toast } from 'react-toastify';
import { OptionType, UserData } from '../types';
import { ClipLoader } from 'react-spinners';
import Button from '../components/global/Button';
import { handleError } from '../utils/errorHandler';
import { useAppDispatch, useAppSelector } from '../app/hooks';
import { setLoggedInUserDetails } from '../features/authentication/authSlice';
import moment from 'moment';
import Modal from '../components/Modal';
import { encryptData } from '../utils/encryptJson';
import { decryptJson } from '../utils/decryptJson';
import { logUserOut } from '../utils/logUserOut';
import customToast, { ToastType } from '../components_/Toast';
import { Request } from '../apis/request';

const Setting = () => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  // const [searchParams] = useSearchParams();
  // const step = searchParams.get('step');
  // console.log(step);
  const [showAddImage, setShowAddImage] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [avatar, setAvatar] = useState<any>({});
  const [loading, setLoading] = useState(false);
  const token: any = localStorage.getItem('login-token');
  const [userData, setUserData] = useState({} as UserData);
  const [date, setDate] = useState<any>('');
  const navigate = useNavigate();

  const [editing, setEditing] = useState(false);
  const [middleName, setMiddleName] = useState('');
  const [gender, setGender] = useState<OptionType>({ label: 'Male', value: 'Male' });
  const [disabled, setDisabled] = useState(false);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const details = useAppSelector((state) => state.auth.loggedInUserDetails);
  const { id } = details;
  const fullName = userData?.firstName + ' ' + userData?.lastName;

  const refreshPage = () => {
    navigate(0);
  };
  const handleShowAddImage = () => {
    setShowAddImage(!showAddImage);
  };
  const dispatch = useAppDispatch();
  const fetchUserInfo = async () => {
    const res = await Request.get(`/user/${id}`, {
      headers: {
        Authorization: `Bearer ${token}`,
        sessId: localStorage.getItem('sessId') ?? '',
      },
      timeout: timeout,
    });
    return res;
  };

  useEffect(() => {
    setGender({ label: userData?.gender, value: userData?.gender });
    setMiddleName(userData?.middleName);
    setDate(userData?.dateOfBirth);
  }, [userData]);
  useEffect(() => {
    if ((userData?.dateOfBirth && userData?.gender) || userData?.middleName) {
      if (
        editing &&
        (userData?.gender?.toUpperCase() !== gender?.value?.toUpperCase() ||
          userData?.middleName !== middleName ||
          moment(userData?.dateOfBirth).format('YYYY-MM-DD') !== moment(date).format('YYYY-MM-DD'))
      ) {
        setDisabled(false);
      } else {
        setDisabled(true);
      }
    } else {
      if (!middleName || !date || !gender) {
        setDisabled(true);
      } else {
        setDisabled(false);
      }
    }
  }, [editing, middleName, gender, userData, date]);

  const gettingInfo = useQuery('user-info', fetchUserInfo, {
    onSuccess: (data) => {
      const res = decryptJson(data?.data?.data);
      setUserData(res?.user);
      setAvatar(res?.user?.profile);
    },
    onError: (error: AxiosError<{ message: string; status?: number }>) => {
      // handleError({ error, errorFn });
      if (error?.response?.data?.status === 593) {
        logUserOut(error?.response?.data?.status);
      }
      customToast('an error occured, please try again', ToastType.error);
    },
  });

  const showErrorToastMessage = (errmsg: string) => {
    customToast(errmsg, ToastType.error);
  };

  const errorFn = (error: AxiosError<{ message: string }>) => {
    if (error?.response?.data?.message) {
      showErrorToastMessage(error.response.data.message);
    } else {
      showErrorToastMessage('Something went wrong');
    }
  };

  const updateUserInfo = useMutation(
    (data: UserData) =>
      Request.patch(`/user`, encryptData(data), {
        headers: {
          Authorization: `Bearer ${token ?? ''}`,
          sessId: localStorage.getItem('sessId') ?? '',
        },
        timeout: timeout,
      }),
    {
      onSuccess: (data) => {
        const res = decryptJson(data?.data?.data);
        const details = res?.user;
        delete details.token;
        dispatch(setLoggedInUserDetails(details));
        customToast('Changes saved successfully', ToastType.success);
        navigate('/settings/business-information?step=2');
      },
      onError: (error: AxiosError<{ message: string }>) => {
        handleError({ error, errorFn });
      },
    },
  );

  const changeDate = (e: any) => {
    setDate(e);
    setEditing(true);
  };

  const changeGender = (e: any) => {
    setGender(e);
    setEditing(true);
  };

  const handleFile = (e: any) => {
    const file = e.target.files[0];
    setSelectedImage(file);
  };

  const handleUpload = async (e: any) => {
    e.preventDefault();
    const photo = selectedImage;
    const formData = new FormData();

    if (photo) {
      formData.append('photo', photo);
    }
    setLoading(true);
    await axios({
      url: `${baseUrl_}/user/profilephoto`,
      method: 'PATCH',
      headers: {
        Authorization: `Bearer ${token ?? ''}`,
        sessId: localStorage.getItem('sessId') ?? '',
      },
      data: formData,
    })
      .then((res) => {
        const response = res.data;
        customToast(response.message, ToastType.success);
        setShowAddImage(false);
        setLoading(false);
        // window.location.reload();
      })
      .catch((err) => {
        if (err?.status === 593) {
          logUserOut(err?.status);
        }
        setLoading(false);

        customToast(err.message, ToastType.error);
      })
      .finally(() => {
        refreshPage();
      });
  };

  const handleDeletePicture = async (e: any) => {
    await axios({
      url: `${baseUrl_}/user/profilephoto`,
      method: 'DELETE',
      headers: {
        Authorization: `Bearer ${token ?? ''}`,
        sessId: localStorage.getItem('sessId') ?? '',
      },
    })
      .then((res) => {
        const response = res.data;
        customToast(response.message, ToastType.success);
        fetchUserInfo();
      })
      .catch((err) => {
        if (err?.status === 593) {
          logUserOut(err?.status);
        }
        customToast(err.message, ToastType.error);
      })
      .finally(() => {
        refreshPage();
      });
  };

  return (
    <Wrapper className=' space-y-3 md:space-y-8  !mr-0'>
      <div className=' md:flex  xl:flex '>
        <div className='min-w-[200px] w-[200px] hidden  md:hidden lg:flex xl:flex'>
          <SettingSteps step={1} />
        </div>

        {gettingInfo?.isLoading || gettingInfo?.isRefetching ? (
          <div className='pt-[20%] w-[100%] flex justify-center items-center'>
            <div>
              <div className='flex justify-center'>
                <ClipLoader
                  color={'#F8B400'}
                  loading={gettingInfo?.isLoading || gettingInfo?.isRefetching}
                  size={50}
                />
              </div>
              Please wait, fetching your info...
            </div>
          </div>
        ) : (
          <div className='flex-2 md:px-[35px] pt-[12px] md:pt-12 md:w-[100%] lg:w-[70%] xl:w-[70%] m-auto'>
            <SettingHeader title='Personal Profile' desc='Complete all required information' />
            <div className='flex space-x-4'>
              {avatar?.photo === null && (
                <div className='w-[87px] h-[87px] bg-green rounded-full flex items-center justify-center text-[38px] font-Poppins font-semibold text-white '>
                  {getInitials(fullName)}
                </div>
              )}
              {avatar?.photo !== null && (
                <div className='w-[87px] h-[87px] bg-green rounded-full flex items-center justify-center text-[38px] font-Poppins font-semibold text-white '>
                  <img
                    src={avatar?.photo}
                    alt={''}
                    className='rounded-full object-cover w-[87px] h-[87px]'
                  />
                </div>
              )}
              <div className='mb-[68px]'>
                <div
                  className='text-[15px]  cursor-pointer font-Poppins py-[12px]  text-green '
                  onClick={handleShowAddImage}
                >
                  <span>+</span> Add image
                </div>
                <div
                  className='text-[15px]  cursor-pointer font-Poppins  text-[#F51010] '
                  onClick={handleDeletePicture}
                >
                  <span>*</span> Delete image
                </div>
              </div>
            </div>
            <div className='mt-[18px]  space-x-4 '>
              <div>
                <div className='lg:flex justify-between items-center gap-[62px] '>
                  <div className='mb-[27px] w-full'>
                    <label className='flex items-center text-[13px] relative mb-[5px] text-[#212121] '>
                      First name
                    </label>
                    <div className='w-full py-[13px] px-[15px] bg-[#F0F6FE] text-[#768396] font-Poppins text-[13px]  border-[1px] border-[#B8C9C9] rounded-[2px] focus:border-[#F8B400] outline-none '>
                      {userData?.firstName}
                    </div>
                  </div>
                  <div className='mb-[27px] flex items-center w-full'>
                    <div className='w-full'>
                      <label className='flex items-center relative text-[13px] mb-[5px] text-[#212121] '>
                        Middle name
                      </label>
                      <input
                        disabled={true}
                        value={middleName ? middleName : userData?.middleName}
                        className='w-full py-[13px]  px-4 border-[1px] border-[#B8C9C9] rounded-[2px] focus:border-[#F8B400] outline-none '
                        onChange={(e) => {
                          setMiddleName(e.target.value);
                          setEditing(true);
                        }}
                      />
                    </div>
                    {/* <div className='ml-[10px] hidden md:hidden xl:block  text-[#F51010] mt-[15px] '>
                                            *
                                        </div> */}
                  </div>
                </div>
                <div className='lg:flex justify-between items-center gap-[62px] '>
                  <div className='mb-[27px] w-full'>
                    <label className='flex items-center text-[13px] relative mb-[5px] text-[#212121] '>
                      Last name
                    </label>
                    <div className='w-full py-[13px] px-[15px] bg-[#F0F6FE] text-[#768396] font-Poppins text-[13px]  border-[1px] border-[#B8C9C9] rounded-[2px] focus:border-[#F8B400] outline-none '>
                      {userData?.lastName}
                    </div>
                  </div>
                  <div className='mb-[27px] flex items-center w-full'>
                    <div className='w-full'>
                      <Dropdown
                        disabled={true}
                        className='border    rounded-[2px] py-[8px] '
                        label='Gender'
                        placeholder={gender?.value}
                        labelStyles='text-[#212121] text-sm font-poppins font-normal leading-[18px] pb-[5px] '
                        options={[
                          { value: 'Male', label: 'Male' },
                          { value: 'Female', label: 'Female' },
                        ]}
                        width='100%'
                        setSelectedOption={changeGender}
                        // req
                      />
                    </div>
                    {/* <div className='ml-[10px] hidden md:hidden xl:block  text-[#F51010] mt-[15px] '>
                                            *
                                        </div> */}
                  </div>
                </div>
                <div className='lg:flex justify-between items-center gap-[62px] '>
                  <div className='mb-[27px] w-full'>
                    <label className='flex items-center text-[13px] relative mb-[5px] text-[#212121] '>
                      Email Address
                    </label>
                    <div className='w-full py-[13px] px-[15px] bg-[#F0F6FE] text-[#768396] font-Poppins text-[13px]  border-[1px] border-[#B8C9C9] rounded-[2px] focus:border-[#F8B400] outline-none '>
                      {userData?.email}
                    </div>
                  </div>
                  <div className='mb-[27px] flex items-center w-full'>
                    <div className='w-full'>
                      <label className='flex items-center  relative text-[13px] mb-[5px] text-[#212121] '>
                        Date of birth
                        {/* <span className=' text-[#F51010] pl-[4px] pt-1 block md:hidden '>*</span> */}
                      </label>
                      <DateInput
                        showLable={false}
                        value={date ? date : userData?.dateOfBirth}
                        req
                        className='!py-[6px]'
                        placeholderText='Enter your birth date'
                        onChange={changeDate}
                        disable={true}
                      />
                    </div>
                    {/* <div className='ml-[10px] hidden md:hidden xl:block  text-[#F51010] mt-[15px] '>
                                            *
                                        </div> */}
                  </div>
                </div>
                <div>
                  <div className='lg:flex justify-between items-center gap-[62px] '>
                    <div className='mb-[27px] w-full'>
                      <label className='flex items-center text-[13px] relative mb-[5px] text-[#212121] '>
                        Country of residence
                      </label>
                      <div className='w-full py-[13px] px-[15px] bg-[#F0F6FE] text-[#768396] font-Poppins text-[13px]  border-[1px] border-[#B8C9C9] rounded-[2px] focus:border-[#F8B400] outline-none '>
                        {userData?.country?.charAt(0).toUpperCase() + userData?.country?.slice(1)}
                      </div>
                    </div>
                    <div className='mb-[27px] flex items-center w-full'>
                      <div className='w-full '>
                        <label className='flex items-center relative text-[13px] mb-[5px] text-[#212121] '>
                          Primary phone number
                        </label>
                        <div className='w-full py-[13px] px-[15px] bg-[#F0F6FE] text-[#768396] font-Poppins text-[13px]  border-[1px] border-[#B8C9C9] rounded-[2px] focus:border-[#F8B400] outline-none '>
                          {userData?.phoneNumber}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div>
                  <Link
                    to='/settings/profile-information/edit?step=1'
                    className='text-[15px]  text-green font-Poppins font-normal '
                  >
                    <img src={editIcon} alt={editIcon} className='w-8' />
                    <span className='pl-3'>Edit Profile information</span>
                  </Link>
                  <div>
                    <p className='inline-block bg-[#76839612] my-[19px] text-[#768295] font-Poppins text-[13px] px-3 py-2 '>
                      Editing your profile will require a new validation of the information provided
                    </p>
                  </div>
                </div>
                {/* <Button
                  type='button'
                  disabled={disabled}
                  loading={updateUserInfo?.isLoading}
                  className='text-[13px] font-Poppins font-medium mt-[64px] text-white bg-green rounded-sm !py-[9px] !px-[49px]'
                  onClick={() => {
                    updateUserInfo.mutate({
                      ...userData,
                      middleName,
                      dateOfBirth: moment(date).format('YYYY-MM-DD'),
                      gender: gender.value.toLowerCase(),
                    });
                  }}
                >
                  SAVE CHANGES
                </Button> */}
              </div>
            </div>
          </div>
        )}
      </div>
      <Modal show={showAddImage} onRequestClose={() => handleShowAddImage()}>
        <form className='space-y-5' onSubmit={handleUpload}>
          <div className='flex items-center justify-between'>
            <div className='flex  flex-col gap-2'>
              <div className='text-base xl:text-lg font-bold text-[#061A14]'>Add Image</div>
            </div>
            <button aria-label='close' onClick={handleShowAddImage}>
              <svg
                width='24'
                height='24'
                viewBox='0 0 24 24'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  fillRule='evenodd'
                  clipRule='evenodd'
                  d='M5.15213 5.1515C5.37716 4.92654 5.68233 4.80016 6.00052 4.80016C6.31872 4.80016 6.62389 4.92654 6.84892 5.1515L12.0005 10.3031L17.1521 5.1515C17.2628 5.03689 17.3952 4.94547 17.5416 4.88258C17.688 4.81969 17.8455 4.78659 18.0048 4.7852C18.1642 4.78382 18.3222 4.81418 18.4697 4.87452C18.6171 4.93485 18.7511 5.02396 18.8638 5.13663C18.9765 5.2493 19.0656 5.38328 19.1259 5.53076C19.1862 5.67823 19.2166 5.83625 19.2152 5.99558C19.2138 6.15492 19.1807 6.31238 19.1178 6.45879C19.055 6.60519 18.9635 6.73761 18.8489 6.8483L13.6973 11.9999L18.8489 17.1515C19.0675 17.3778 19.1885 17.6809 19.1857 17.9956C19.183 18.3102 19.0568 18.6112 18.8343 18.8337C18.6118 19.0562 18.3108 19.1824 17.9962 19.1851C17.6816 19.1878 17.3784 19.0669 17.1521 18.8483L12.0005 13.6967L6.84892 18.8483C6.6226 19.0669 6.31948 19.1878 6.00484 19.1851C5.69021 19.1824 5.38923 19.0562 5.16674 18.8337C4.94425 18.6112 4.81805 18.3102 4.81532 17.9956C4.81258 17.6809 4.93354 17.3778 5.15213 17.1515L10.3037 11.9999L5.15213 6.8483C4.92716 6.62327 4.80078 6.3181 4.80078 5.9999C4.80078 5.68171 4.92716 5.37654 5.15213 5.1515Z'
                  fill='#515B6F'
                />
              </svg>
            </button>
          </div>
          <label className='flex flex-col relative text-[#212121] '>
            {/* <div className='flex gap-2'> */}
            <div className='w-full text-[13px] font-poppins  text-left  mb-1'>
              {'Profile Picture'}
              {` `}
              {/* {invalid && <span className='text-[red] text-[10px]'>Invalid file format</span>} */}
              {/* {invalid && <p className='text-[red] text-xs'>{`   Invalid file format`}</p>} */}
            </div>
            {/* </div> */}
            <div className='w-[100%] sm:flex sm:gap-2'>
              <div className={['w-[100%]'].join(' ')}>
                <input
                  className='appearance-none hidden'
                  type='file'
                  onChange={handleFile}
                  accept='image/*'
                />
                <div>
                  <div className='w-full dashed-file mt-[4px] relative px-4 bg-[#F8F8FD] flex flex-col items-center rounded-[5px] outline-none cursor-pointer !gap-[7px] py-3'>
                    <svg
                      width='27'
                      height='27'
                      viewBox='0 0 27 27'
                      fill='none'
                      xmlns='http://www.w3.org/2000/svg'
                    >
                      <path
                        d='M1.99781 14.954C2.03132 14.9253 2.06722 14.8982 2.09834 14.8671C3.07729 13.8857 4.05625 12.9052 5.03361 11.9222C5.17084 11.7842 5.31924 11.6709 5.51072 11.6119C5.87694 11.4978 6.19687 11.5791 6.46335 11.84C6.96999 12.3363 7.46704 12.8429 7.96889 13.3448C8.16117 13.5371 8.35505 13.7277 8.54892 13.9184C8.68216 14.0493 8.69573 14.0501 8.83455 13.912C9.9268 12.8206 11.0191 11.7283 12.1113 10.6361C12.665 10.0824 13.2243 9.53426 13.7692 8.97258C14.145 8.58482 14.7921 8.58722 15.1758 8.97577C16.1907 10.005 17.2183 11.0222 18.2404 12.0443C18.8132 12.6163 19.3861 13.1884 19.9565 13.7628C20.4472 14.2567 20.3299 15.021 19.7172 15.3394C19.3797 15.5149 18.9042 15.4495 18.6257 15.1742C18.0688 14.6229 17.5191 14.0652 16.9654 13.5115C16.1636 12.7089 15.3609 11.9071 14.5575 11.1052C14.5352 11.0829 14.5048 11.0685 14.4618 11.0382C14.3501 11.1451 14.24 11.2472 14.1338 11.3534C13.0599 12.4281 11.9868 13.5043 10.9137 14.579C10.4542 15.0394 9.99382 15.499 9.53346 15.9577C9.46804 16.0231 9.40022 16.087 9.32922 16.1476C8.91274 16.5034 8.37739 16.4875 7.98724 16.0997C7.35136 15.4678 6.72026 14.8312 6.08677 14.1969C6.03012 14.1402 5.97587 14.082 5.91683 14.0285C5.80513 13.928 5.7804 13.9272 5.6687 14.0357C5.47323 14.2248 5.27935 14.4155 5.08707 14.6078C4.10173 15.5915 3.11958 16.5784 2.13105 17.559C2.00419 17.6851 1.94674 17.8143 1.94914 17.9954C1.95791 18.7326 1.96829 19.4706 1.94754 20.2071C1.93238 20.7655 2.42864 21.2107 2.95442 21.2091C6.76813 21.1964 10.5818 21.2036 14.3963 21.2012C14.6899 21.2012 14.9437 21.2825 15.1527 21.49C15.57 21.9057 15.5253 22.587 15.0554 22.9421C14.8711 23.0809 14.6628 23.1535 14.4283 23.1535C10.5747 23.1527 6.72106 23.1631 2.86666 23.1463C1.68585 23.1415 0.646255 22.4243 0.199462 21.2794C0.0646255 20.9323 0 20.5701 0 20.1943C0.00159569 14.4482 0 8.70131 0.00159569 2.95522C0.00159569 2.0002 0.382168 1.21672 1.12337 0.619926C1.4824 0.331106 1.89648 0.146804 2.35923 0.0606363C2.63768 0.00877631 2.91214 0 3.18979 0C8.86487 0 14.5392 0 20.2134 0.000797846C20.8485 0.000797846 21.4301 0.179515 21.9448 0.555301C22.3812 0.874439 22.729 1.27576 22.9261 1.78079C23.0625 2.13105 23.1599 2.49726 23.1599 2.88102C23.1591 6.72744 23.1591 10.5739 23.1599 14.4203C23.1599 14.9971 22.6852 15.5173 22.0397 15.4208C21.6894 15.3681 21.4333 15.1718 21.2881 14.8399C21.2203 14.6844 21.2068 14.5232 21.2068 14.3548C21.2083 10.5619 21.2068 6.76813 21.2107 2.97517C21.2107 2.70151 21.1437 2.46375 20.9602 2.26269C20.7879 2.0736 20.5733 1.9651 20.3148 1.95153C20.2685 1.94914 20.2214 1.95073 20.1751 1.95073C14.441 1.95073 8.7069 1.95153 2.97277 1.94834C2.66161 1.94834 2.39833 2.03451 2.19009 2.26828C2.0385 2.43822 1.95472 2.63529 1.95233 2.86507C1.95153 2.94485 1.95153 3.02463 1.95153 3.10442C1.95153 6.9644 1.95153 10.8236 1.95153 14.6836C1.95153 14.7689 1.95153 14.8543 1.95153 14.9397C1.96749 14.9445 1.98265 14.9492 1.99781 14.954Z'
                        fill='#768396'
                      />
                      <path
                        d='M23.1602 21.1902C23.2711 21.1958 23.3493 21.2021 23.4267 21.2029C24.2836 21.2037 25.1405 21.2157 25.9966 21.199C26.5223 21.1886 27.0992 21.6442 26.9867 22.3439C26.9268 22.7157 26.7019 22.967 26.3444 23.0811C26.1968 23.1282 26.0349 23.1505 25.8793 23.1513C25.0695 23.1577 24.2588 23.1545 23.4482 23.1545C23.1602 23.1545 23.1594 23.1545 23.1594 23.4521C23.1594 24.309 23.1698 25.1651 23.1554 26.0219C23.1459 26.6139 22.6281 27.1333 21.9244 26.9618C21.5167 26.8629 21.2103 26.4671 21.2095 26.0411C21.2063 25.1842 21.2087 24.3281 21.2087 23.4712C21.2087 23.4178 21.2055 23.3651 21.2087 23.3117C21.2151 23.2047 21.1736 23.1481 21.0603 23.1537C21.0076 23.1569 20.9542 23.1537 20.9007 23.1537C20.051 23.1537 19.2005 23.1569 18.3508 23.1521C17.995 23.1505 17.7021 22.9965 17.5115 22.6997C17.1724 22.1723 17.3918 21.542 17.9303 21.2971C18.0644 21.2365 18.2239 21.2077 18.3715 21.2069C19.2284 21.199 20.0853 21.2029 20.9414 21.2029C21.0196 21.2029 21.097 21.2029 21.1927 21.2029C21.1991 21.1 21.2079 21.0234 21.2079 20.946C21.2087 20.0828 21.2159 19.2195 21.2055 18.3562C21.1999 17.9166 21.5095 17.4196 22.072 17.3533C22.5116 17.3015 22.8985 17.5145 23.0772 17.9701C23.1339 18.1137 23.1546 18.2788 23.1562 18.4344C23.1634 19.2642 23.1594 20.0947 23.1594 20.9245C23.1602 21.0035 23.1602 21.0825 23.1602 21.1902Z'
                        fill='#768396'
                      />
                      <path
                        d='M8.67213 9.64935C7.10994 9.66451 5.78951 8.36881 5.78712 6.76275C5.78392 5.1511 7.09239 3.85061 8.70165 3.86337C10.3077 3.87534 11.5922 5.13833 11.5875 6.77232C11.5827 8.38317 10.2734 9.66691 8.67213 9.64935ZM7.73386 6.75796C7.73067 7.29651 8.15034 7.72176 8.69846 7.71218C9.2729 7.70181 9.63194 7.25901 9.64789 6.75557C9.66146 6.32792 9.26892 5.79735 8.69686 5.79815C8.16869 5.79815 7.72828 6.21144 7.73386 6.75796Z'
                        fill='#768396'
                      />
                    </svg>
                    <span className='text-[#515B6F]'>
                      <span className='text-black'>
                        {!selectedImage ? `Click to uplaod` : `Change image`}
                      </span>
                    </span>
                  </div>
                  <div className='mt-[11px] pb-[10px] font-poppins text-[#768396] text-xs '>
                    Supported document: jpeg, jpg, png
                  </div>

                  {/* <span className='font-medium max-w-[200px] truncate overflow-hidden text-sm text-center font-epilogue text-dark-100'>
                    {fileUploaded ? watchValue[0]?.name : 'Attach Document'}
                    </span> */}
                </div>
              </div>

              {selectedImage && (
                <div className='flex flex-col gap-1 '>
                  <img
                    src={URL.createObjectURL(selectedImage)}
                    alt='checkedImg'
                    className='h-[100px] w-[120px]'
                  />
                  {/* <div className='text-[10px]'>{selectedImage && selectedImage.size}</div> */}
                </div>
              )}
            </div>
          </label>
          <div className='mt-6'>
            <div className='w-full'>
              <Button
                type='submit'
                size='sm'
                loading={loading}
                className='text-sm w-full xl:text-base font-normal  '
              >
                {loading ? 'Uploading' : 'Upload'}
              </Button>
            </div>
          </div>
        </form>
      </Modal>
    </Wrapper>
  );
};

export default Setting;
